function buocHoSo() {
  return [
    {
      target: "body",
      placement: "center",
      title: "Bước 1 · Hồ sơ của tôi",
      content: "Xem thông tin tài khoản đang đăng nhập và đổi mật khẩu tại đây.",
    },
    {
      target: "#tour-ho-so-thong-tin",
      title: "Bước 2 · Thông tin cá nhân",
      content:
        "Họ tên và số điện thoại hiển thị cho đồng nghiệp — email và vai trò do quản trị viên đặt, không tự đổi được ở đây.",
      placement: "top",
    },
    {
      target: "#tour-ho-so-doi-mat-khau",
      title: "Bước 3 · Đổi mật khẩu",
      content:
        "Nhập mật khẩu hiện tại để xác nhận là bạn, rồi mật khẩu mới nếu muốn tự đổi mật khẩu đăng nhập — mật khẩu mới phải có ít nhất 6 ký tự theo yêu cầu của Firebase Auth, cùng quy tắc với trang Đặt lại mật khẩu.",
      placement: "top",
    },
  ];
}

export default buocHoSo;
